export default "__VITE_ASSET__BFGifUmq__"